import { useState } from 'react';

// Alleen de standaardtoetsen uit de eigen organisatie, al opgehaald door ToetsForm.
// De keuzelijst haalt geen eerder ingevoerde leerlingresultaten op.
export default function ToetsChoice({ templates, onApply }) {
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState('');
  const [message, setMessage] = useState('');
  const choose = value => {
    setMessage('');
    if (!value) { setSelected(''); return; }
    const template = templates.find(t => `template:${t.id}` === value);
    if (!template) { setSelected(''); return; }
    if (onApply({ title: template.title, parts: template.parts, template_id: template.id })) {
      setSelected(value);
      setMessage('Titel en onderdelen overgenomen. Vul de resultaten voor deze leerling in.');
    } else {
      setSelected('');
    }
  };
  const filteredTemplates = templates.filter(t => t.title.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase()));
  return <section className="toets-choice mb-4" aria-label="Standaardtoets kiezen">
    <label className="form-label" htmlFor="toets-choice">Standaardtoets <span className="text-muted">(optioneel)</span></label>
    <input className="form-control mb-2" type="search" placeholder="Zoek een standaardtoets…"
      aria-label="Zoek een standaardtoets" value={search} maxLength={200} onChange={e => { setSearch(e.target.value); setSelected(''); }} />
    <select id="toets-choice" className="form-select" value={selected} onChange={e => choose(e.target.value)}>
      <option value="">Kies een standaardtoets, of voer zelf een titel in</option>
      {filteredTemplates.map(t => <option key={t.id} value={`template:${t.id}`}>{t.title}</option>)}
      {!filteredTemplates.length && <option disabled>Geen standaardtoetsen gevonden</option>}
    </select>
    <div className="form-text">Kies een standaardtoets om de titel en onderdelen over te nemen, of vul hieronder zelf een titel en onderdelen in.</div>
    {message && <div className="text-success small mt-2" role="status">{message}</div>}
  </section>;
}
